// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeUnaffiliated = {
  ctfAuthDataContractInvalid:
    "The CTF current-user role contract is invalid. Contact an administrator",
  eduAuthDataContractInvalid:
    "The EDU current-user role contract is invalid. Contact an administrator",
  eduAuthMemberAccessRequired: "Your account does not have EDU portal access yet",
  eduDependencyDatabaseUnavailable: "The database is temporarily unavailable. Try again later",
  microLabAuthDataContractInvalid:
    "The Micro Lab current-user role contract is invalid. Contact an administrator",
  microLabMemberContractInvalid:
    "The Micro Lab member role contract is invalid. Contact an administrator",
  platformIntelligenceAuditTokenUsageInvalid:
    "The intelligence audit token usage field {field} is invalid. Contact an administrator",
  platformKnowledgeLibraryAuthInvalidAppSession:
    "The knowledge library session has expired. Sign in again",
  platformToolsLibraryContractInvalidEnum:
    "The tools library filter enum is invalid. Refresh and try again, or contact an administrator",
  redblueMemberContractInvalid:
    "The RedBlue member role contract is invalid. Contact an administrator",
  toolsLibraryDownloadFilenameMissing:
    "The tool download response is missing a file name. Contact an administrator",
} as const;
